import { getGlobalProps } from './inappGlobalProps';
import { subscribe } from './metricSubscription';
import { isIOS } from './util';
const validInitiatorTypes = {
    script: true,
    link: true,
    img: true,
    css: true,
};
const state = {
    isActualFMPSent: false,
};
let unknownFirstScreenRequests = [];
const unknownFirstScreenRequestMax = 5;
let observer;
let actualFMPSubscription;
const addUnknownFirstScreenRequest = (req) => {
    unknownFirstScreenRequests.push(req);
    if (unknownFirstScreenRequests.length > unknownFirstScreenRequestMax) {
        unknownFirstScreenRequests.shift();
    }
};
const resourceObserver = (list, resourceChecked, pathFilter, fn) => {
    list.getEntries().forEach((e) => {
        var _a, _b;
        const entry = e;
        const lcPath = (_b = (_a = entry.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        if (lcPath && !resourceChecked[lcPath] && validInitiatorTypes[entry.initiatorType]) {
            let resourceType = 'unknown';
            if (pathFilter.common.find((x) => lcPath.includes(x))) {
                resourceType = 'common';
            }
            else if (pathFilter.app.find((x) => lcPath.includes(x))) {
                resourceType = 'app';
            }
            const perfEntry = entry;
            let fromGecko = 'unknown';
            if (perfEntry.serverTiming) {
                fromGecko = perfEntry.serverTiming.length === 0 ? 'true' : 'false';
            }
            resourceChecked[lcPath] = true;
            if (resourceType === 'unknown') {
                if (!state.isActualFMPSent) {
                    // 在没有上报核心指标之前，把这些都塞进去
                    addUnknownFirstScreenRequest({ path: entry.name, fromGecko });
                }
            }
            else {
                fn({
                    path: entry.name,
                    fromGecko,
                    isFirstScreen: state.isActualFMPSent ? 'false' : 'true',
                    resourceType,
                });
            }
        }
        else if (!resourceChecked[lcPath]) {
            resourceChecked[lcPath] = true;
        }
    });
};
export const startResourceMonitor = async (geckoResPath, fn) => {
    try {
        if (isIOS()) {
            return;
        }
        actualFMPSubscription = subscribe('actualFmp', () => {
            state.isActualFMPSent = true;
            actualFMPSubscription === null || actualFMPSubscription === void 0 ? void 0 : actualFMPSubscription.unsubscribe();
            unknownFirstScreenRequests.forEach((req) => {
                fn({
                    path: req.path,
                    fromGecko: req.fromGecko,
                    isFirstScreen: 'true',
                    resourceType: 'unknown',
                });
            });
            unknownFirstScreenRequests = [];
        });
        const resourceChecked = {};
        const pathFilter = {
            common: ['/gando_libs/', '/tiktok_fonts/'],
            app: [],
        };
        if (geckoResPath) {
            pathFilter.app.push(geckoResPath);
        }
        try {
            const geckoPathPrefix = process.env.GECKO_PATH_PREFIX;
            if (geckoPathPrefix) {
                pathFilter.app.push(geckoPathPrefix);
            }
        }
        catch {
            // do nothing
        }
        try {
            const cdnPathPrefix = process.env.CDN_PATH_PREFIX;
            if (cdnPathPrefix) {
                pathFilter.app.push(cdnPathPrefix);
            }
        }
        catch {
            // do nothing
        }
        const geckoChannelName = await getGlobalProps('geckoChannelName');
        if (geckoChannelName) {
            pathFilter.app.push(geckoChannelName);
        }
        observer = new PerformanceObserver((list) => resourceObserver(list, resourceChecked, pathFilter, fn));
        observer.observe({ type: 'resource', buffered: true });
    }
    catch {
        // do nothing
    }
};
export const stopResourceMonitor = () => {
    observer === null || observer === void 0 ? void 0 : observer.disconnect();
    actualFMPSubscription === null || actualFMPSubscription === void 0 ? void 0 : actualFMPSubscription.unsubscribe();
};
//# sourceMappingURL=resourceMonitor.js.map